import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppSvgIconComponent, SignalButton } from '@vallift/ngl';
import { PageHeaderComponent } from '@core/components/page-header/page-header.component';
import { PeopleToolbarService } from './people-toolbar.service';

@Component({
  selector: 'app-people-page',
  standalone: true,
  imports: [
    AppSvgIconComponent,
    PageHeaderComponent,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    SignalButton,
  ],
  templateUrl: './people-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeoplePage implements OnInit {
  private readonly router = inject(Router);
  private readonly toolbar = inject(PeopleToolbarService);
  private readonly destroyRef = inject(DestroyRef);

  readonly tabs = [
    {
      label: 'Contacts',
      link: '/people/contacts',
      iconSrc: 'assets/icons/account-outline.svg',
    },
    {
      label: 'Groups',
      link: '/people/groups',
      iconSrc: 'assets/icons/account-multiple-outline.svg',
    },
  ] as const;

  readonly createLabel = signal('New contact');

  ngOnInit(): void {
    this.syncCreateLabel(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.syncCreateLabel(event.urlAfterRedirects);
      });
  }

  onCreate(): void {
    this.toolbar.requestCreate();
  }

  private syncCreateLabel(url: string): void {
    this.createLabel.set(
      url.includes('/people/groups') ? 'New group' : 'New contact',
    );
  }
}
